/* src/app/components/session-info/charge-speed-info/charge-speed-info.component.scss */
ion-text {
  white-space: nowrap;
}
/*# sourceMappingURL=charge-speed-info.component.css.map */
